import React, { useEffect } from 'react';
import { Form, Switch, Select, Input } from 'antd';
import ResponsiveModal from '../../../Shared/ResponsiveModal/ResponsiveModal';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const SettingsModal = ({ isVisible, onCancel, onSubmit, autoChargeSettings, products, loading }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (autoChargeSettings) {
      form.setFieldsValue({
        auto_reload_enabled: autoChargeSettings.auto_reload_enabled,
        auto_reload_product_id: autoChargeSettings.auto_reload_product_id,
        auto_reload_threshold: autoChargeSettings.auto_reload_threshold
      });
    }
  }, [autoChargeSettings, form]);

  const handleOk = () => {
    form.submit();
  };

  const validateThreshold = (_, value) => {
    const selectedProductId = form.getFieldValue('auto_reload_product_id');
    const selectedProduct = products.find(product => product.id === selectedProductId);

    if (!selectedProduct) {
      return Promise.reject(new Error(t('select_plan_required')));
    }

    if (value < 1) {
      return Promise.reject(new Error(t('valid_threshold')));
    }

    if (value > selectedProduct.coins) {
      return Promise.reject(new Error(t('valid_threshold')));
    }

    return Promise.resolve();
  };

  const isEnabled = Form.useWatch('auto_reload_enabled', form);

  return (
    <ResponsiveModal
      title={t('auto_recharge_settings')}
      open={isVisible}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
      confirmLoading={loading}
      desktopWidth={520}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={autoChargeSettings}
        onFinish={(values) => onSubmit(values, form)}
      >
        <Form.Item
          label={t('auto_reload_enabled')}
          name="auto_reload_enabled"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item
          label={t('recharge_plan')}
          name="auto_reload_product_id"
          rules={[{ required: isEnabled, message: t('select_plan_required') }]}
        >
          <Select placeholder={t('select_plan')} disabled={!isEnabled}>
            {products.map(product => (
              <Option key={product.id} value={product.id}>
                {product.title} ({product.coins} coins)
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label={t('trigger_threshold')}
          name="auto_reload_threshold"
          rules={isEnabled ? [
            { required: true, message: t('threshold_required') },
            { validator: validateThreshold }
          ] : []}
          normalize={(value) => Number(value)}
        >
          <Input type="number" addonAfter={t('coins')} disabled={!isEnabled} />
        </Form.Item>
      </Form>
    </ResponsiveModal>
  );
};

export default SettingsModal; 
